export enum UploadImageTypeEnum {
    profile = 1,
    cover = 2,
    media = 3
}